import * as Sentry from "@sentry/react";
import { AxiosError } from "axios";

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            maskAllInputs: false,
        }),
    ],
    enabled: import.meta.env.MODE !== "development",
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        "localhost",
        /^https:\/\/dev-transpor\.netlify\.app\//,
        /^https:\/\/dev-transpor\.netlify\.app\/api/,
        /^https:\/\/transport\.elitklinik\.io/,
        /^https:\/\/transport\.elitklinik\.io\/api/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    beforeSend: (event, hint) => {
        const exception = hint.originalException as AxiosError;

        if (hint && exception && exception.isAxiosError) {
            if (exception.response && exception.response.data) {
                let contexts = {
                    ...event.contexts,
                };
                contexts.errorResponse = {
                    data: exception?.response?.data,
                };
                event.contexts = contexts;
            }
        }
        return event;
    },
});

// Sentry.init({
//     dsn: "https://ae55b32b730c346ece2693fb2eb32b38@o4507385235570688.ingest.de.sentry.io/4508779646812240",
//     integrations: [
//         // See docs for support of different versions of variation of react router
//         // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
//         Sentry.reactRouterV6BrowserTracingIntegration({
//             useEffect,
//             useLocation,
//             useNavigationType,
//             createRoutesFromChildren,
//             matchRoutes,
//         }),
//         Sentry.replayIntegration(),
//     ],

//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for tracing.
//     // Learn more at
//     // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
//     tracesSampleRate: 1.0,

//     // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
//     tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],

//     // Capture Replay for 10% of all sessions,
//     // plus for 100% of sessions with an error
//     // Learn more at
//     // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,
// });
